import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { DocumentsModule } from './pages/documents/documents.module';
import { CalculatorsModule } from './pages/calculators/calculators.module';
import { MainModule } from './pages/main/main.module';
import { PricingModule } from './pages/pricing/pricing.module';
import { SolutionPersonalisedModule } from './pages/solution-personalised/solution-personalised.module';
import { Solution1Module } from './pages/solution1/solution1.module';
import { Solution2Module } from './pages/solution2/solution2.module';
import { Solution3Module } from './pages/solution3/solution3.module';
import { MyImmoHelpModule } from './pages/myimmo-help/myimmo-help.module';
import { Calculator1Module } from './pages/calculator1/calculator1.module';
import { Calculator2Module } from './pages/calculator2/calculator2.module';
import { Calculator3Module } from './pages/calculator3/calculator3.module';
import { Calculator4Module } from './pages/calculator4/calculator4.module';
import { Solution4Module } from './pages/solution4/solution4.module';
import { Solution5Module } from './pages/solution5/solution5.module';
import { Solution6Module } from './pages/solution6/solution6.module';
import { FiscalGuideModule } from './pages/fiscal-guide/fiscal-guide.module';
import { ManagementToolModule } from './pages/management-tool/management-tool.module';
import { TodoModule } from './pages/todo/todo.module';
import { CardPaymentSuccessModule } from './pages/card-payment/card-payment-success/card-payment-success.module';
import { CardPaymentCancelModule } from './pages/card-payment/card-payment-cancel/card-payment-cancel.module';
import { CardPaymentModule } from './pages/card-payment/card-payment/card-payment.module';
//import { CardPaymentDirectModule } from './pages/card-payment/card-payment-direct/card-payment-direct.module';
import { RegisterModule } from './pages/authentication/register/register.module';
import { LoginModule } from './pages/authentication/login/login.module';
import { FooterAboutUsModule } from './pages/footer-about-us/footer-about-us.module';
import { FooterCareersModule } from './pages/footer-careers/footer-careers.module';
import { FooterBlogModule } from './pages/footer-blog/footer-blog.module';
import { FooterPressModule } from './pages/footer-press/footer-press.module';
import { FooterCollaborationModule } from './pages/footer-collaboration/footer-collaboration.module';
import { ContactModule } from './pages/contact/contact.module';
import { PrivacyModule } from './pages/legal/privacy/privacy.module';
import { PrivacyPolicyModule } from './pages/legal/privacy-policy/privacy-policy.module';
import { CookiePreferencesModule } from './pages/legal/cookie-preferences/cookie-preferences.module';
import { TermsModule } from './pages/legal/terms/terms.module';
import { GdprModule } from './pages/legal/gdpr/gdpr.module';
import { FooterSitemapModule } from './pages/footer-sitemap/footer-sitemap.module';
import { ProductsModule } from './pages/products/products.module';
import { ProfileModule } from './pages/profile/profile.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/main',
    pathMatch: 'full'
  },
  {
    path: 'main',
    component: LayoutComponent,
    loadChildren: () => MainModule
  },
  {
    path: 'solution1',
    component: LayoutComponent,
    loadChildren: () => Solution1Module
  },
  {
    path: 'solution2',
    component: LayoutComponent,
    loadChildren: () => Solution2Module
  },
  {
    path: 'solution3',
    component: LayoutComponent,
    loadChildren: () => Solution3Module
  },
  {
    path: 'solution4',
    component: LayoutComponent,
    loadChildren: () => Solution4Module
  },
  {
    path: 'solution5',
    component: LayoutComponent,
    loadChildren: () => Solution5Module
  },
  {
    path: 'solution6',
    component: LayoutComponent,
    loadChildren: () => Solution6Module
  },
  {
    path: 'pricing',
    component: LayoutComponent,
    loadChildren: () => PricingModule
  },
  {
    path: 'products',
    component: LayoutComponent,
    loadChildren: () => ProductsModule
  },
  {
    path: 'solution-personalised',
    component: LayoutComponent,
    loadChildren: () => SolutionPersonalisedModule
  },
  {
    path: 'blog-list',
    component: LayoutComponent,
    loadChildren: () => import('./../app/pages/blog-list/blog-list.module').then(m => m.BlogListModule)
  },
  {
    path: 'blog-post',
    component: LayoutComponent,
    loadChildren: () => import('./../app/pages/blog-post/blog-post.module').then(m => m.BlogPostModule)
  },
  {
    path: 'blog-contact',
    component: LayoutComponent,
    loadChildren: () => import('./../app/pages/blog-contact/blog-contact.module').then(m => m.BlogContactModule)
  },
  {
    path: 'blog-search/:id',
    component: LayoutComponent,
    loadChildren: () => import('./../app/pages/blog-search/blog-search.module').then(m => m.BlogSearchModule)
  },
  {
    path: 'calculators',
    component: LayoutComponent,
    loadChildren: () => CalculatorsModule
  },
  {
    path: 'calculator1',
    component: LayoutComponent,
    loadChildren: () => Calculator1Module
  },
  {
    path: 'calculator2',
    component: LayoutComponent,
    loadChildren: () => Calculator2Module
  },
  {
    path: 'calculator3',
    component: LayoutComponent,
    loadChildren: () => Calculator3Module
  },
  {
    path: 'calculator4',
    component: LayoutComponent,
    loadChildren: () => Calculator4Module
  },
  {
    path: 'documents',
    component: LayoutComponent,
    loadChildren: () => DocumentsModule
  },
  {
    path: 'help',
    component: LayoutComponent,
    loadChildren: () => MyImmoHelpModule
  },
  {
    path: 'fiscal-guide',
    component: LayoutComponent,
    loadChildren: () => FiscalGuideModule
  },
  {
    path: 'management-tool',
    component: LayoutComponent,
    loadChildren: () => ManagementToolModule
  },
  {
    path: 'todo',
    component: LayoutComponent,
    loadChildren: () => TodoModule
  },
  {
    path: 'about-us',
    component: LayoutComponent,
    loadChildren: () => FooterAboutUsModule
  },
  {
    path: 'careers',
    component: LayoutComponent,
    loadChildren: () => FooterCareersModule
  },
  {
    path: 'blog',
    component: LayoutComponent,
    loadChildren: () => FooterBlogModule
  },
  {
    path: 'press',
    component: LayoutComponent,
    loadChildren: () => FooterPressModule
  },
  {
    path: 'collaboration',
    component: LayoutComponent,
    loadChildren: () => FooterCollaborationModule
  },
  {
    path: 'contact',
    component: LayoutComponent,
    loadChildren: () => ContactModule
  },
  {
    path: 'legal/privacy',
    component: LayoutComponent,
    loadChildren: () => PrivacyModule
  },
  {
    path: 'legal/privacy-policy',
    component: LayoutComponent,
    loadChildren: () => PrivacyPolicyModule
  },
  {
    path: 'legal/cookie-preferences',
    component: LayoutComponent,
    loadChildren: () => CookiePreferencesModule
  },
  {
    path: 'legal/terms',
    component: LayoutComponent,
    loadChildren: () => TermsModule
  },
  {
    path: 'legal/gdpr',
    component: LayoutComponent,
    loadChildren: () => GdprModule
  },
  {
    path: 'sitemap',
    component: LayoutComponent,
    loadChildren: () => FooterSitemapModule
  },
  {
    path: 'card-payment',
    component: LayoutComponent,
    loadChildren: () => CardPaymentModule
  },
  {
    path: 'card-payment-success',
    component: LayoutComponent,
    loadChildren: () => CardPaymentSuccessModule
  },
  {
    path: 'card-payment-success/:sessionId',
    component: LayoutComponent,
    loadChildren: () => CardPaymentSuccessModule
  },
  {
    path: 'card-payment-cancel',
    loadChildren: () => CardPaymentCancelModule
  },
  {
    path: 'register',
    loadChildren: () => RegisterModule
  },
  {
    path: 'login',
    loadChildren: () => LoginModule
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/authentication/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'profile',
    component: LayoutComponent,
    loadChildren: () => ProfileModule
  },
  {
    path: 'external-download',
    component: LayoutComponent,
    children: [
      {
        path: '**',
        loadChildren: () => CardPaymentSuccessModule
      }
    ]
  },
  {
    path: 'external-route',
    children: [
      {
        path: '**',
        component: LayoutComponent,
        data: { externalRoute: true }
      }
    ]
  },
  // {
  //   path: 'document-download',
  //   loadChildren: () => CardPaymentDirectModule
  // },
  {
    path: '**',
    component: LayoutComponent,
    runGuardsAndResolvers: 'always'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'top',
    anchorScrolling: 'disabled',
    useHash: false,
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }

